/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import PassageImage from '../../components/PassageImage/PassageImage';
import SnapshotApproachTitle from './SnapshotApproachTitle';

interface MultipleSnapshotViewProps {
  approaches: any[];
  snapTs: number;
  setExpandedIdx: (idx: number) => void;
}

const MultipleSnapshotView: React.FC<MultipleSnapshotViewProps> = ({
  approaches,
  snapTs,
  setExpandedIdx,
}) => {
  const numberOfApproaches = approaches.length;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Box
      display="grid"
      gridTemplateColumns={matches ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'}
      gap={1}
      p={2}
      sx={{
        overflow: 'auto',
        height: matches ? '100%' : 'calc(100% - 40px)',
        paddingBottom: '0px',
        marginBottom: '0px',
        minWidth: matches ? '600px' : '100%',
        minHeight: numberOfApproaches > 2 ? '472px' : '236px',
      }}
    >
      {approaches.map((approach: any, idx: number) => (
        <Box
          key={approach.direction}
          sx={{
            textAlign: 'center',
            maxWidth: 'auto',
          }}
        >
          {matches && (idx === 0 || idx === 1) && (
            <SnapshotApproachTitle direction={approach.direction} />
          )}
          <Box
            sx={{
              marginLeft: idx === 1 || idx === 3 ? 1 : 0,
              marginRight: idx === 0 || idx === 2 ? 1 : 0,
            }}
          >
            <PassageImage
              filename={approach.filename}
              description={approach.description}
              imageUrl={import.meta.env.VITE_REACT_APP_CAMERA_URL}
              onClick={() => setExpandedIdx(idx)}
              clickable
            />
          </Box>

          {(!matches || idx === 2 || idx === 3) && (
            <SnapshotApproachTitle direction={approach.direction} />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default MultipleSnapshotView;
